import React from 'react';
import { connect } from 'react-redux';
import { Header } from './Header';
import { Upgrades } from './Upgrades';
import { Schemes } from './Schemes';
import { Map } from './Map';
import { Terrain } from './Terrain';
import { Inventory } from './Inventory';
import { Settings } from './Settings';

import {
  addCoins,
  removeCoins,
  updateWeight,
} from '../actions/ResourcesActions';
import {
  addItemToInventory,
  removeItemFromInventory,
} from '../actions/InventoryActions';
import {
  loadGameState,
  setActiveWindow,
  setWindowPosition,
  toggleSettingsPopup,
  updateSettings,
  updateWindows,
  updateWindowStack,
} from '../actions/InterfaceAction';
import { updateTerrain, updateTerrainBlock } from '../actions/TerrainActions';
import { upgradeItem } from '../actions/UpgradesAction';
import { updatePlanet, generateStartLocation } from '../actions/PlanetAction';

import UpgradeTypes from './UpgradeTypes';
import SchemeTypes from './SchemeTypes';
import { getRandomInt } from './Mathround';
import Window from './ui/Window';
import Desktop from './ui/Desktop';
const seedrandom = require('seedrandom');

class Main extends React.Component {
  state = {
    clicks: 0,
    totalUpgrades: 0,
    gold: 0,
    hueRotate: 0,
    seed: 0,
    drill: {
      speed: 1,
      quality: 1,
      name: 'Basic Drill',
    },
    schemes: SchemeTypes,
    upgrades: UpgradeTypes,
    terrain: [],
    settingsOpen: false,
    autoSave: false,
    extractorMoving: false,
    ui: {
      windows: [],
      activeWindow: null,
    },
  };

  constructor(props) {
    super(props);
    let stateData = JSON.parse(localStorage.getItem('gameData'));
    if (stateData !== null) {
      if (stateData.autoSave) {
        localStorage.clear('gameData');
        window.location.reload();
      }
      if (stateData.settings.autoSave) {
        this.props.loadGameStateAction(stateData);
        setTimeout(() => {
          this.props.updatePlanetAction(
            stateData.planet,
            stateData.terrain.position
          );
        }, 100);
      } else {
        setTimeout(() => {
          this.props.generateStartLocationAction({
            ...props.planet,
            seed:
              seedrandom(getRandomInt(1, 100000000000))() * 100000000000000000,
            map: [],
          });
        }, 100);
      }
    } else {
      setTimeout(() => {
        this.props.generateStartLocationAction({
          ...props.planet,
          seed:
            seedrandom(getRandomInt(1, 100000000000))() * 100000000000000000,
          map: [],
        });
      }, 100);
    }
  }

  render() {
    return (
      <Desktop ui={this.props.ui} redux={this.props}>
        <Map
          id={1}
          planet={this.props.planet}
          position={this.props.terrain.position}
        />
        <Window
          id={'header'}
          redux={this.props}
          state={'active'}
          resizable={false}
          header="engine0"
          children={<Header data={this.state} redux={this.props} />}
          w={300}
          h={200}
          minH={200}
        />
        <Window
          id={'terrain'}
          redux={this.props}
          state={'active'}
          resizable
          header="Terrain"
          children={<Terrain data={this.state} redux={this.props} />}
          w={854}
          h={480}
          lockAspectRatio
        />
        <Window
          id={'upgrades'}
          redux={this.props}
          state={'hidden'}
          resizable
          header="Upgrades"
          children={<Upgrades redux={this.props} />}
          w={620}
          h={360}
          minH={200}
          minW={240}
          maxW={620}
        />
        <Window
          id={'schemes'}
          redux={this.props}
          state={'hidden'}
          resizable
          header="Schemes"
          children={<Schemes data={this.state} redux={this.props} />}
          h={172}
          w={300}
          minH={172}
        />
        <Window
          id={'inventory'}
          redux={this.props}
          state={'active'}
          resizable
          header="Inventory"
          children={
            <Inventory data={this.state.inventory} redux={this.props} />
          }
          h={172}
          w={300}
          minH={172}
        />
        <Window
          id={'settings'}
          redux={this.props}
          state={'active'}
          resizable={false}
          header="Settings"
          children={<Settings data={this.state} redux={this.props} />}
          w={380}
          h={200}
          minH={200}
        />
      </Desktop>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    planet: store.planet,
    terrain: store.terrain,
    upgrades: store.upgrades,
    schemes: store.schemes,
    inventory: store.inventory,
    settings: store.settings,
    resources: store.resources,
    drill: store.drill,
    ui: store.ui,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCoinsAction: (coins) => dispatch(addCoins(coins)),
    removeCoinsAction: (coins) => dispatch(removeCoins(coins)),
    updateWeightAction: (weight) => dispatch(updateWeight(weight)),
    addItemToInventoryAction: (item) => dispatch(addItemToInventory(item)),
    removeItemFromInventoryAction: (item) =>
      dispatch(removeItemFromInventory(item)),
    loadGameStateAction: (state) => dispatch(loadGameState(state)),
    toggleSettingsPopupAction: (isOpen) =>
      dispatch(toggleSettingsPopup(isOpen)),
    updateSettingsAction: (settings) => dispatch(updateSettings(settings)),
    setActiveWindowAction: (windowID) => dispatch(setActiveWindow(windowID)),
    setWindowPositionAction: (windowID, coordinates) =>
      dispatch(setWindowPosition({ id: windowID, coordinates: coordinates })),
    updateWindowsAction: (windows) => dispatch(updateWindows(windows)),
    updateWindowStackAction: (windowStack) =>
      dispatch(updateWindowStack(windowStack)),
    generateStartLocationAction: (planet) =>
      dispatch(generateStartLocation(planet)),
    updatePlanetAction: (planet, position) =>
      dispatch(updatePlanet(planet, position)),
    updateTerrainAction: (terrain, planet) =>
      dispatch(updateTerrain(terrain, planet)),
    updateTerrainBlockAction: (terrainBlock) =>
      dispatch(updateTerrainBlock(terrainBlock)),
    upgradeItemAction: (item) => dispatch(upgradeItem(item)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
